import React, { Component } from 'react'
import Swal from "sweetalert2";
import "../css/general-style.css"
import '../css/table-responsive.css'
import "../css/pickingSystem-style.css"
import Select from 'react-select';
import { AiOutlineComment } from "react-icons/ai"
import { FiTrash, FiSave, FiCheckCircle, FiRefreshCw, FiCheckSquare } from "react-icons/fi";
import { FiWifi, FiWifiOff, FiUsers, FiPackage, FiActivity } from "react-icons/fi";
import CustomerListV2 from '../components/CustomerListV2';
import { getValueCookie } from '../services/cookieService';
import { create_Delete_Update_Information, getInformationWithData, saveJsonData } from '../services/CABE'
import { DateFormatMAS90, FormatQueryReturnDateForReport, getActualDateUTC, getDateYearMonthDayDash } from '../functions/dateFormat';
import LoadingWindow from '../components/LoadingWindow';
import PreSalesOrderList from '../components/PreSalesOrderList';
import { confirmCloseAlert } from '../functions/alerts';
import { getPrintHeaderCompany } from '../functions/companyInformation';
import { OrderPDF } from '../components/OrderPDF';
import SmallModal from '../components/SmallModal';
import { pricesFormat } from '../functions/pricesFormat';
import { DecimalPart, getPriceMargin, getPurePriceMargin, MobileDisp, NumberFormat, OrderArray, validateNumbersForQuantitys } from '../functions/generalFunctions';
import SearchUPC from '../components/SearchUPC';
import { getIndexElement } from '../functions/searchInObject';
import PreCatalogue from '../components/Catalogue2.0/PreCatalogue';
import { DownloadOrderPDF } from '../components/DownloadOrderPDF';
// Menu
import { Menu } from "../components/Menu/Menu";


export default class PreSalesOrder extends Component {
  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
    // Validate if new order was created
    const newSOstatus = localStorage.getItem('isNotNewSO');

    this.state = {
      disable: false,
      isInputFocused: false,
      ConfirmSave: 0,
      ProductList: [],
      ProductsForAltitude: [],
      Products: [],
      syncItemsStatus: "pending",
      syncCustomersStatus: "pending",
      syncImagesStatus: "done",
      SalesOrder: {
        Customer: {
          AddressLine1: '',
          City: '',
          CustomerName: '',
          CustomerNo: '',
          EmailAddress: '',
          PriceLevel: undefined,
          SalespersonNo: '',
          State: '',
          TelephoneNo: '',
          ZipCode: '',
          uniqueTrack: '',
        },
        NoOrder: '',
        Type: 'S',
        TotalQuantityOrdered: 0,
        TotalCost: 0,
        TotalWeight: 0,
        Date: getDateYearMonthDayDash(),
        Warehouse: '000',
        Packing: null,
        WeightOption: null,
        MAS90Status: 0,
        TotalLines: 0,
        Duplicate: false,
        status: null,
      },
      Balance: {
        HeaderBalance: [],
        TermsCode: '',
        TotalBalance: 0,
        SelectedInvoice: '',
        Detail: []
      },

      companyPrintHeader: getPrintHeaderCompany(),
      showModal1: false,
      confirmMargin: false,
      NotZeroUnitPrice: true,
      selectOptions1: [

        { value: 'Transparent Stretch Wrap', label: 'Transparent Stretch Wrap' },
        { value: 'Black Stretch Wrap', label: 'Black Stretch Wrap' },
        { value: 'Not Packing (Customer Collect) ', label: 'Not Packing (Customer Collect)' }
      ],
      selectOptions2: [
        { value: '003', label: 'B&B Miami Warehouse Price Level 4' },//4
        { value: '000', label: 'Mayaland Atlanta Warehouse Price Level 3' }//5
      ],
      selectOptions3: [

        { value: 'Weighed', label: 'Weighed' },
        { value: 'No need to be Weighed', label: 'No need to be Weighed' }
      ],
      enableEdit: false,
      isMayalandOrder: true,
      isNotNewSO: newSOstatus && newSOstatus === true ? true : false,
      newSalesOrder: false,
      isOnline: navigator.onLine,
      wasOffline: false,
      showSyncPanel: false,
      selectedWarehouse: null,
      selectedPacking: "Transparent Stretch Wrap",
      selectedWeight: "Weighed",
      mode: 'create', // 'create' | 'edit'
    }
    this.toggleSyncPanel = this.toggleSyncPanel.bind(this);
  }

  SO_CACHE_KEY = 'offline_sales_order_v1';
  __soSaveTimer = null;
  __prevSOSerialized = '';

  // Cambiar el status para el panel de status de sincronizacion
  toggleSyncPanel() {
    this.setState({ showSyncPanel: !this.state.showSyncPanel });
  }

  /** Guarda el SalesOrder actual al cache (localStorage) */
  saveSalesOrderToCache = () => {
    try {
      const json = JSON.stringify(this.state.SalesOrder);
      localStorage.setItem(PreSalesOrder.SO_CACHE_KEY, json);
    } catch (err) {
      console.error('saveSalesOrderToCache failed:', err);
    }
  };

  /** Debounce para evitar escribir en cada cambio micro */
  scheduleSaveSalesOrder = () => {
    clearTimeout(this.__soSaveTimer);
    this.__soSaveTimer = setTimeout(this.saveSalesOrderToCache, 300);
  };

  /** Carga del cache y fusiona con el estado actual (mantiene defaults) */
  loadSalesOrderFromCache = () => {
    try {
      const raw = localStorage.getItem(PreSalesOrder.SO_CACHE_KEY);
      if (!raw) return;

      const cached = JSON.parse(raw);
      if (!cached || typeof cached !== 'object') return;

      // Merge conservando tus defaults actuales
      const merged = {
        ...this.state.SalesOrder,
        ...cached,
        Customer: {
          ...this.state.SalesOrder.Customer,
          ...(cached.Customer || {}),
        },
      };

      this.setState({ SalesOrder: merged }, () => {
        // guarda la huella para que el primer didUpdate no vuelva a guardarlo
        this.__prevSOSerialized = JSON.stringify(this.state.SalesOrder);
      });
    } catch (err) {
      console.error('loadSalesOrderFromCache failed:', err);
    }
  };

  /** Limpia el cache (llámala cuando completes y envíes la SO al backend) */
  clearSalesOrderCache = () => {
    Swal.fire({
      title: 'Before to continue',
      text: "Are you sure to clear the Sales Order cache? This will remove the order data.",
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Yes, clear',
      cancelButtonText: 'No, cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        localStorage.removeItem(PreSalesOrder.SO_CACHE_KEY);
        localStorage.removeItem('SalesOrderSave');
        localStorage.removeItem('isNotNewSO');
        this.clearSalesOrder();
      }
    })
  }

  // Handle online flag
  handleOnline = () => {
    this.setState({ isOnline: true });
    console.log("Conectado a internet");
  };

  // Handle offline flag
  handleOffline = () => {
    this.setState({ isOnline: false, wasOffline: true });
    console.log("Sin conexión a internet");
  };


  setupBeforeUnloadListener = () => {
    if (this.state.Products.length > 0) {
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        ev.returnValue = '';
        return this.doSomethingBeforeUnload();
      });
    }
  };

  // Preload for update pre sales order
  loadOrder = async (orderNo) => {
    try {
      const data = { orderNo: orderNo };

      const res = await getInformationWithData('/pre-sales/order/complete-details', data);

      if (res.status.code !== 1) {
        alert('Error loading order');
        return;
      }

      // console.log(res);

      const header = res.data.header || {};
      const detail = (res.data.detail && Array.isArray(res.data.detail))
      ? res.data.detail
      : []
      console.log("detail");
      console.log(detail);

      // MAP HEADER (a tu estructura real)
      let SalesOrder = { ...this.state.SalesOrder };

      SalesOrder.NoOrder = header.order_no;
      SalesOrder.Warehouse = header.warehouse;
      SalesOrder.MAS90Status = header.mas90_status;
      SalesOrder.TotalLines = header.total_lines;
      SalesOrder.TotalQuantityOrdered = header.total_quantity_ordered;
      SalesOrder.TotalCost = header.total_cost;
      SalesOrder.TotalWeight = header.total_weight;
      SalesOrder.Duplicate = header.duplicate;
      if (header.date) {
        const d = new Date(header.date);
        SalesOrder.Date = d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0');
      } else {
        SalesOrder.Date = '';
      }

      console.log(SalesOrder.Date);

      // Packing split
      if (header.packing) {
        const parts = header.packing.split(';');
        this.setState({
          selectedPacking: parts[0] || null,
          selectedWeight: parts[1] || null
        });
      }

      // Customer
      SalesOrder.Customer = {
        ...SalesOrder.Customer,
        CustomerNo: header.customer_no,
        CustomerName: header.customer_name,
        SalespersonNo: header.salesperson_no
      };

      // MAP PRODUCTS
      const Products = detail.map((item) => {
        return {
          itemCode: item.item_code || '',
          abbreviatedDesc: item.abbreviated_desc || '',

          // CLAVE (el UI usa esto)
          quantityOrdered: Number(item.quantity || 0),

          // CLAVE (el UI usa esto)
          UnitPrice: Number(item.unit_price || 0),

          unitCost: Number(item.unit_cost || 0),

          // CLAVE (el UI usa esto)
          totalCost: Number(item.total_cost || 0),

          ShipWeight: Number(item.ship_weight || 0),
          totalWeight: Number(item.total_weight || 0),

          Comment: item.comment || '',
          ProductLine: item.product_line || '',
          ProductLineDesc: item.product_line_desc || '',

          Visible: item.visible ? true : false,

          LineSequence: item.line_sequence || 0,

          HaveUPC: item.have_upc ? true : false,

          InputValue: Number(item.input_value || 0),

          upc: item.upc || '',
          upc2: item.upc2 || '',
          caseupc: item.caseupc || '',
          BIN: item.bin || '',

          // CLAVE (el UI usa esto)
          itemURLImage: item.image_url || ''
        };
      });
      
      SalesOrder.Packing = this.state.selectedPacking;
      SalesOrder.WeightOption = this.state.selectedWeight;

      // SET STATE FINAL
      this.setState({
        SalesOrder: SalesOrder,
        Products: Products,
        enableEdit: true
      }, () => {
        this.refreshInputs();
        this.calculateTotals();
      });

    } catch (err) {
      console.log(err);
      alert('Error loading order');
    }
  };

  async getNewCorrelativeSalesOrder() {
    if (!this.state.wasOffline) {
      this.clearSalesOrder();
    }

    const data = {
      type: 'SalesOrder',
      idCompany: getValueCookie('CompanyId')
    };

    const result = await getInformationWithData('/sales/get/correlative', data);
    if (result.status.code === 1) {
      const temporal = this.state.SalesOrder
      temporal.NoOrder = (getValueCookie('CompanyId') === '6' ? 'AL' : 'PM') + result.data[0].correlative;
      this.setState({ SalesOrder: temporal });
    }
  }

  async offlineNewOrder() {
    let temporal = {
      ConfirmSave: 0,
      confirmMargin: false,
      NotZeroUnitPrice: true,
      Customer: {
        AddressLine1: '',
        City: '',
        CustomerName: '',
        CustomerNo: '',
        EmailAddress: '',
        PriceLevel: undefined,
        SalespersonNo: '',
        State: '',
        TelephoneNo: '',
        ZipCode: '',
        uniqueTrack: '',
      },
      TotalLines: 0,
      NoOrder: '',
      Type: 'S',
      TotalQuantityOrdered: 0,
      TotalCost: 0,
      TotalWeight: 0,
      Date: getDateYearMonthDayDash(),
      Warehouse: '000',
      Packing: null,
      WeightOption: null,
      MAS90Status: 0,
      Duplicate: false,
    };
    temporal.NoOrder = 'OFFLINE';
    this.setState({ SalesOrder: temporal, offlinePendingWork: true });
  }

  valueRadioButton = async e => {
    let stat = e.target.value
    const temporal = this.state.SalesOrder
    temporal.Type = stat
    this.setState({ SalesOrder: temporal })
  }

  calculateTotals() {
    let totalQuantity = 0
    let totalCost = 0
    let totalWeight = 0
    let totalPrice = 0
    const temporal = this.state.Products
    const temporal2 = this.state.SalesOrder

    for (const item of temporal) {

      totalPrice += Number(item.LastTotalUnitCost) * Number(item.quantityOrdered)
      totalQuantity += Number(item.quantityOrdered)
      totalCost += Number(item.totalCost)
      totalWeight += Number(item.quantityOrdered) * Number(item.ShipWeight)
    }

    temporal2.TotalQuantityOrdered = totalQuantity
    temporal2.TotalCost = totalCost
    temporal2.TotalWeight = totalWeight
    temporal2.Customer.uniqueTrack = getPriceMargin(totalCost, totalPrice, temporal2.Customer.PriceLevel)
    this.setState({ SalesOrder: temporal2 })
    this.AutoSave()
  }

  async getItemList() {
    const data = {
      companyId: "3"
    }
    try {
      let response = await getInformationWithData('/Items/getListV2', data);
      this.setState({ ProductList: response.data })
    } catch (error) {
      console.log(error)
    }
  }

  setAltPrice(item) {
    let altitudePrice = item.LastTotalUnitCost / 0.95;
    altitudePrice = altitudePrice / (1 - (item.MarkUp / 100));
    return altitudePrice;
  }

  checkMinPrice(temporal, newValue) {
    const productList = this.state.ProductList;
    const originalItem = productList.find(item => item.itemCode === temporal.itemCode);
    const newPrice = Number(newValue.target.value);
    const n1Price = originalItem.UnitPrice

    if (newPrice < n1Price) {
      let altitudePrice = this.setAltPrice(originalItem);

      if (altitudePrice < n1Price) {
        altitudePrice = n1Price;
      }

      const totalCost = temporal.quantityOrdered * altitudePrice;

      this.setState((prevState) => ({
        Products: prevState.Products.map((item) =>
          item.itemCode === temporal.itemCode
            ? { ...item, UnitPrice: Number(altitudePrice.toFixed(2)), totalCost: totalCost }
            : item
        )
      }))
      alert(`The lower price for this product is $${NumberFormat(pricesFormat(n1Price))}`)
      return false
    }
    return true
  }

  onTargetChange(e, product) {
    let newPrice = e.target.value;
    this.setState((prevstate) => {
      const updatedProducts = prevstate.Products.map((item) => {
        if (item.itemCode === product.itemCode) {
          return { ...item, UnitPrice: newPrice };
        }
        return item
      });
      return { Products: updatedProducts }
    })
  }

  onTarget = async (e, item) => {
    const temporal = this.state.Products
    const ident = e.target.id.split('_')
    const index = temporal.indexOf(item)

    if (index !== -1) {
      if (ident[0] === "quantityOrderedSalesOrder") {
        let quant = Number(e.target.value)

        if (!validateNumbersForQuantitys(quant)) {
          let parteDecimal = 1 - DecimalPart(quant)
          quant += parteDecimal
          document.getElementById(e.target.id).value = quant
        }

        temporal[index].quantityOrdered = Number(quant)
        temporal[index].totalCost = (Number(quant) * Number(temporal[index].UnitPrice))
        this.setState({ Products: temporal, ConfirmSave: 0 })
        this.calculateTotals()
      } else if (ident[0] === "unitPriceSalesOrder") {
        temporal[index].UnitPrice = Number(e.target.value)
        temporal[index].totalCost = (Number(e.target.value) * Number(temporal[index].quantityOrdered))
        if (getValueCookie('CompanyId') === '6') {
          // temporal[index].Comment = "BOX:" + getPriceMargin(temporal[index].UnitPrice, temporal[index].unitCost, this.state.SalesOrder.Customer.PriceLevel)
          temporal[index].Comment = "BOX:" + this.state.SalesOrder.Customer.CustomerName
          temporal[index].PureMargin = getPurePriceMargin(temporal[index].UnitPrice, temporal[index].unitCost)

        }
        if (getValueCookie('CompanyId') === '6') {
          // if (this.checkMinPrice(temporal[index], e) && getValueCookie('TypeUser') !== '1') {
            this.setState({ Products: temporal, ConfirmSave: 0 })
            this.calculateTotals()
          // } else {
          // }
        } else {
          this.setState({ Products: temporal, ConfirmSave: 0 })
          this.calculateTotals()
        }
      }
    }
    await this.AutoSave()
    this.setState({ isInputFocused: false });
  }

  checkInputFocus = () => {
    this.setState({ isInputFocused: true });
  }

  clearSalesOrder() {
    const clear = {
      ConfirmSave: 0,
      confirmMargin: false,
      NotZeroUnitPrice: true,
      Customer: {
        AddressLine1: '',
        City: '',
        CustomerName: '',
        CustomerNo: '',
        EmailAddress: '',
        PriceLevel: undefined,
        SalespersonNo: '',
        State: '',
        TelephoneNo: '',
        ZipCode: '',
        uniqueTrack: '',
      },
      TotalLines: 0,
      NoOrder: '',
      Type: 'S',
      TotalQuantityOrdered: 0,
      TotalCost: 0,
      TotalWeight: 0,
      Date: getDateYearMonthDayDash(),
      Warehouse: '000',
      Packing: null,
      WeightOption: null,
      MAS90Status: 0,
      Duplicate: false,
    }
    this.setState({ SalesOrder: clear, Products: [], enableEdit: false })
    localStorage.removeItem('SalesOrderSave')
  }

  addComentary(item) {
    let comm = item.Comment
    Swal.fire({
      title: 'Product: ' + item.itemCode,
      html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfSalesOrder' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
      backdrop: true,
      showCancelButton: true,
      confirmButtonText: 'Save Commentary',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const temporal = this.state.Products
        const index = temporal.indexOf(item)
        if (index !== -1) {
          const coment = Swal.getPopup().querySelector('#comentOfSalesOrder').value
          temporal[index].Comment = coment
          this.setState({ Products: temporal })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    })
    this.AutoSave()
  }

  removeProduct(item) {
    let temporal = this.state.Products
    const index = temporal.indexOf(item)

    if (index !== -1) {
      temporal[index].quantityOrdered = 0
      temporal[index].totalCost = 0
      temporal[index].Visible = 0

      for (let a = 0; a < temporal.length; a++) {
        document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
        document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
      }

      this.setState({ Products: temporal })
      this.calculateTotals()
    }
    this.AutoSave()
  }

  refreshInputs() {
    const temporal = this.state.Products
    for (let a = 0; a < temporal.length; a++) {
      document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
      document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
    }
  }

  AsignLineSequence() {
    const head = this.state.SalesOrder
    if (getValueCookie('CompanyId') === '6') {
      const temporal = OrderArray(JSON.parse(JSON.stringify(this.state.Products)), 'IdCompany', true)

      let confirmMargin = false
      let NotZeroUnitPrice = true
      let count = 1
      let activeLines = 0
      for (const item of temporal) {
        item.LineSequence = count
        item.quantityShipped = 0
        count++
        if (!confirmMargin) {
          confirmMargin = item.PureMargin > 20 ? false : true
        }
        if (item.UnitPrice <= 0 && item.Visible === 1) {
          NotZeroUnitPrice = false
        }
        if (item.Visible !== 0) {
          activeLines++
        }
      }

      head.TotalLines = activeLines
      this.setState({ confirmMargin: confirmMargin, NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
      return temporal
    } else {
      const temporal = this.state.Products
      let NotZeroUnitPrice = true
      let count = 1
      let activeLines = 0
      for (const item of temporal) {
        item.LineSequence = count
        item.quantityShipped = 0
        count++
        if (item.UnitPrice <= 0 && item.Visible === 1) {
          NotZeroUnitPrice = false
        }
        if (item.Visible !== 0) {
          activeLines++
        }
      }
      head.TotalLines = activeLines
      this.setState({ NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
      return temporal
    }
  }

  detailToPrint() {
    let items = []
    this.state.Products.forEach(element => {
      if (element.Visible === 1) {
        element.abbreviatedDesc = (element.completeDesc && element.completeDesc !== "null") ? element.completeDesc : element.abbreviatedDesc
        items.push(element)
      }
    });
    return items
  }

  async updateMayalandSO(altitudeSO) {
    let mayalandTemporal = altitudeSO;
    mayalandTemporal.idCompany = "3"
    mayalandTemporal.company = 'Mayaland Atlanta'
    mayalandTemporal.Customer.CustomerNo = '0016027';
    mayalandTemporal.Detail = this.updateAltitudePrices(mayalandTemporal.Detail);

    // const result = await create_Delete_Update_Information('/pre-sales/set/order', mayalandTemporal)
    await create_Delete_Update_Information('/pre-sales/set/order', mayalandTemporal)
  }

  updateAltitudePrices(productList) {
    productList.forEach(element => {
      const altitudePrice = element.LastTotalUnitCost / 0.95;
      element.UnitPrice = Number(altitudePrice.toFixed(2))
    });
    return productList;
  }

  async checkSalesOrderStatus(SONumber) {
    const data = {
      SalespersonNo: getValueCookie('SalesPerson'),
      idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
    }
    const response = await getInformationWithData('/sales/get/header', data);
    const salesOrderList = response.data;

    const getSalesOrder = salesOrderList.find(obj => obj.SalesOrderNo === SONumber)
    if (getSalesOrder) {
      return getSalesOrder.Status;
    }
    return 0
  }

  async createSalesOrderSync(LoadMas90) {
    console.log("CREAR CON OFFLINE")
    // Se creo offline y no tiene correlative
    await this.getNewCorrelativeSalesOrder();
    this.createSalesOrder(LoadMas90);
  }

  async createSalesOrder(LoadMas90) {
    await this.AsignLineSequence()
    Swal.fire({
      title: 'Are you sure to save this order?',
      text: "",
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Yes, please',
      cancelButtonText: 'No, cancel!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const temporal = JSON.parse(JSON.stringify(this.state.SalesOrder))
        temporal.Detail = this.AsignLineSequence();
        temporal.idCompany = getValueCookie('CompanyId');
        temporal.username = getValueCookie('userName');
        temporal.company = getValueCookie('Company');
        temporal.OrderType = 'SalesOrder';
        temporal.MAS90Status = LoadMas90;
        temporal.Packing = this.state.selectedPacking + ";" + this.state.selectedWeight;
        // Save raw data
        await saveJsonData('/store/json', temporal)

        if (getValueCookie('CompanyId') !== '6' || (getValueCookie('CompanyId') === '6' && !this.state.confirmMargin)) {
          
          if ((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption) || getValueCookie('CompanyId') === '6') {
            const result = await create_Delete_Update_Information('/pre-sales/set/order', temporal)
            if (result.status.code === 1) {
              this.setState({ ConfirmSave: this.state.Products.length })
              await this.SaveAndPrint()
              await confirmCloseAlert('correct', 'The order was saved successfully!')
              localStorage.removeItem('SalesOrderSave')
              if (getValueCookie('CompanyId') === '6') {
                // await this.updateCompanyPrices(temporal)
                this.updateMayalandSO(temporal)
              }
              // salesOrderDoubleCheck(temporal)
            } else {
              confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')
            }
          } else {
            if (!this.state.SalesOrder.Packing) {
              Swal.fire({
                title: 'You need select a Type of Packing to Save this Sales Order!',
                text: "",
                icon: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showCancelButton: false,
                confirmButtonText: 'Ok'
              })
            } else {
              Swal.fire({
                title: 'You need select if the order are Weighed or No need to be Weighed',
                text: "",
                icon: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showCancelButton: false,
                confirmButtonText: 'Ok'
              })
            }
          }
        } else {
          const result = await create_Delete_Update_Information('/pre-sales/set/order', temporal)
          if (result.status.code === 1) {
            this.setState({ ConfirmSave: this.state.Products.length });
            await this.SaveAndPrint();
            confirmCloseAlert('correct', 'The order was saved successfully!');
            localStorage.removeItem('SalesOrderSave');
            
            // Notes - Not necesary for pre sales order
            // if (getValueCookie('CompanyId') === '6') {
            //   this.updateMayalandSO(temporal)
            // }

          } else {
            confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')
          }
        }
      }

      // Enable to edit
      if ((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption)) {
        this.setState({ enableEdit: true })
      }

      // Enable to edit
      if (getValueCookie('CompanyId') === '6') {
        this.setState({ enableEdit: true })
      }

      // Clear SO cache
      // this.clearSalesOrderCache();
    })
  }

  // Validate cookies
  checkSessionOrRedirect() {
    const companyId = getValueCookie('CompanyId');
    const userName = getValueCookie('userName');

    if (!companyId || !userName) {
      window.location.href = '/login';
      return false;
    }
    return true;
  }

  componentDidMount() {
    // Validate cookie
    if (!this.checkSessionOrRedirect()) return;

    // Verify if is create or edit order by URL
    const params = new URLSearchParams(window.location.search);
    const orderNoFromUrl = params.get('orderNo');

    if (orderNoFromUrl) {
      this.setState({ mode: 'edit' });
      this.loadOrder(orderNoFromUrl);
    }

    if (localStorage.getItem('SalesOrderSave')) {
      // Get added products
      let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));

      if (infoRec) {
        this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
      }

      if (infoRec.SalesOrder.Customer.CustomerNo === '0016027' && getValueCookie('CompanyId') !== '6') {
        this.setState({ isMayalandOrder: false })
      }
    }
    window.addEventListener('storage', this.handleStorageChange);
    if (getValueCookie('CompanyId') === '6') {
      // this.getItemList();
    }

    // Carga la sales order desde cache
    this.loadSalesOrderFromCache();
    // Toma la huella del estado inicial, por si no hay cache
    this.__prevSOSerialized = JSON.stringify(this.state.SalesOrder);

    // Handle online / offline
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);
  }

  componentDidUpdate(prevProps, prevState) {
    // Detecta cambios en SalesOrder (comparación por serialización)
    try {
      const curr = JSON.stringify(this.state.SalesOrder);
      if (curr !== this.__prevSOSerialized) {
        this.__prevSOSerialized = curr;
        this.scheduleSaveSalesOrder();
      }
    } catch (err) {
      // si algo raro hay en el estado, evita romper la UI
      console.error('componentDidUpdate compare failed:', err);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
    // Limpiar cache de la sales order
    clearTimeout(this.__soSaveTimer);
    // Handle online / offline
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  }

  // Auto sabe sales order changes
  AutoSave() {
    localStorage.setItem('SalesOrderSave', JSON.stringify(this.state));
  }

  TypeInLetters(type) {
    if (type === 'S') {
      return 'Standard'
    } else {
      return 'Quote'
    }
  }

  handleModalOpen = (modal) => {
    this.setState({ [modal]: true })
  }

  handleModalClose = (modal) => {
    this.setState({ [modal]: false })
  }

  handleStorageChange = async (event) => {
    if (event.key === 'SalesOrderSave') {
      let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
      if (infoRec) {
        if (infoRec.SalesOrder.NoOrder === this.state.SalesOrder.NoOrder) {
          await this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
          await this.refreshInputs()
        }
      }
    }
  }

  getTotalBalance() {
    let currentBalance = 0

    this.state.Balance.HeaderBalance.forEach(line => {
      currentBalance += Number(line.Balance)
    });

    const temporal = this.state.Balance
    temporal.TotalBalance = currentBalance
    this.setState({ Balance: temporal })
  }

  async getDetailBalance(LineBalance) {

    const data = {
      idCompany: Number(getValueCookie('CompanyId')),
      InvoiceNo: LineBalance.InvoiceNo
    }
    this.ModalLoading.current.showState(true);
    const result = await getInformationWithData('/invoice/history/getInvoicePayment', data)
    if (result.status.code === 1) {
      const temporal = this.state.Balance
      temporal.Detail = result.data
      temporal.SelectedInvoice = LineBalance.InvoiceNo
      this.setState({ Balance: temporal })
    }
    this.ModalLoading.current.showState(false);
  }

  validationNewSalesOrder() {
    if (this.state.Products.length !== this.state.ConfirmSave) {
      Swal.fire({
        title: 'Are you sure to Start a new Sales Order, you have a Sales Order open and unsave?',
        icon: 'info',
        showDenyButton: true,
        confirmButtonText: `Yes, I'm sure.`,
        denyButtonText: `Not`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.getNewCorrelativeSalesOrder();
        }
      })
    } else {
      this.getNewCorrelativeSalesOrder();
    }

    // Set cache for new SO status
    localStorage.setItem('isNotNewSO', false);
    // Update state
    this.setState({ isNotNewSO: false, newSalesOrder: true });
  }

  onChangeSelects = async (e, id) => {
    const temporal = this.state.SalesOrder
    switch (id) {
      case "Warehouse":
        temporal.Warehouse = e.value;
        this.setState({ SalesOrder: temporal, selectedWarehouse: e.value });
        this.changePriceLevel(e.value);
        break;
      case "Packing":
        temporal.Packing = e.value;
        this.setState({ SalesOrder: temporal, selectedPacking: e.value });
        break;
      case "Weight":
        temporal.WeightOption = e.value;
        this.setState({ SalesOrder: temporal, selectedWeight: e.value });
        break;
      default:
        break;
    }
  }

  changePriceLevel(id) {
    const temporal = this.state.SalesOrder
    switch (id) {
      case "003":
        temporal.Customer.PriceLevel = '4'
        this.setState({ SalesOrder: temporal })
        break;
      case "000":
        temporal.Customer.PriceLevel = '3'
        this.setState({ SalesOrder: temporal })
        break;

      default:
        break;
    }
  }

  async OnlySaveSO() {
    const temporal = this.state.SalesOrder
    temporal.Detail = this.AsignLineSequence()
    temporal.idCompany = getValueCookie('CompanyId')
    temporal.username = getValueCookie('userName')
    temporal.company = getValueCookie('Company')
    temporal.OrderType = 'SalesOrder'
    await create_Delete_Update_Information('/pre-sales/set/order', temporal)
  }

  async TemporalSaveSystem() {
    const temporal = this.state.SalesOrder
    temporal.Detail = this.AsignLineSequence()
    temporal.idCompany = getValueCookie('CompanyId')
    temporal.username = getValueCookie('userName')
    temporal.company = getValueCookie('Company')
    temporal.OrderType = 'SalesOrder'
    if (temporal.idCompany === '6') {
      await create_Delete_Update_Information('/sales/post/savetemporal', temporal)
    }
  }

  async SaveAndPrint() {
    let button = document.getElementById('SalesOrderPrint')
    if (button) {
      button.click()
    }
  }

  disable() {
    this.setState({ disable: true })
  }

  render() {
    const { isOnline, wasOffline } = this.state;
    var syncCustomersStatus = this.state.syncCustomersStatus; // 'started' | 'done' | undefined
    var syncItemsStatus = this.state.syncItemsStatus;         // 'started' | 'done' | undefined
    var syncImagesStatus = this.state.syncImagesStatus;         // 'started' | 'done' | undefined

    // color del boton del FAB
    var allDone = isOnline && syncCustomersStatus === 'done' && syncItemsStatus === 'done' && syncImagesStatus === 'done';
    var anyStarted = syncCustomersStatus === 'started' || syncItemsStatus === 'started' || syncImagesStatus === 'started';
    var dotColor = allDone ? '#10b981' : (isOnline ? (anyStarted ? '#f59e0b' : '#6b7280') : '#ef4444');

    return (
      <div>
        <div id="GeneralPages" className="page">
          {/* Main menu */}
          <Menu Refresh={this.state.Refresh} Father={this} />

          <div className="container-fluid generalContainer contPrincipal" id="actualPage">
            {/* Loading modal */}
            <LoadingWindow ref={this.ModalLoading} />

            {/* Hero */}
            <div className='text-center my-4'>
              <h2 className='display-5 fw-bold inventory-title'>
                {this.state.mode === 'edit'
                  ? `Editing Order ${this.state.SalesOrder.NoOrder}`
                  : 'Pre Sales Order'}
              </h2>
              
              {this.state.mode !== 'edit' ? 
                <p className='lead text-muted inventory-subtitle'>Creating or Select an order.</p>
              : null}
            </div>

            {/* FAB flotante */}
            <button className="fab-sync" onClick={this.toggleSyncPanel} aria-label="Sync status">
              {isOnline ? <FiActivity /> : <FiWifiOff />}
              <span className="fab-dot" style={{ background: dotColor }} />
            </button>

            {/* Panel flotante */}
            {this.state.showSyncPanel ? (
              <div className="fab-panel">
                <h4>{isOnline ? <span><FiWifi style={{ marginRight: 6 }} />Connected</span> : <span><FiWifiOff style={{ marginRight: 6 }} />No connection</span>}</h4>

                {/* Customer */}
                <div className="sync-row" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <FiUsers />
                  <span>Customer synchronized</span>
                  {syncCustomersStatus === 'started' ? (
                    <span className="sync-badge started"><span className="spin">⟳</span> syncing…</span>
                  ) : syncCustomersStatus === 'done' ? (
                    <span className="sync-badge done">done ✓</span>
                  ) : (
                    <span className="sync-badge idle">idle</span>
                  )}
                </div>

                {/* Items */}
                <div className="sync-row" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <FiPackage />
                  <span>Items synchronized</span>
                  {syncItemsStatus === 'started' ? (
                    <span className="sync-badge started"><span className="spin">⟳</span> syncing…</span>
                  ) : syncItemsStatus === 'done' ? (
                    <span className="sync-badge done">done ✓</span>
                  ) : (
                    <span className="sync-badge idle">idle</span>
                  )}
                </div>

                {/* Items images */}
                <div className="sync-row" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <FiPackage />
                  <span>Images synchronized</span>
                  {syncImagesStatus === 'started' ? (
                    <span className="sync-badge started"><span className="spin">⟳</span> syncing…</span>
                  ) : syncImagesStatus === 'done' ? (
                    <span className="sync-badge done">done ✓</span>
                  ) : (
                    <span className="sync-badge idle">idle</span>
                  )}
                </div>
              </div>
            ) : null}

            {getValueCookie('CompanyId') === '3' && this.state.SalesOrder.Customer.CustomerNo === '0016027' ?
              <div className="alert alert-primary" role="alert">
                <h4>Consultation-Only View</h4>
                <p>This order is managed by Altitude Distribution Corp.</p>
                <p>Any updates or corrections must be made directly in the respective portal. This view is for consultation purposes only.</p>
                <hr />
                <p>If you have any questions, please contact IT support.</p>
              </div>
              : null}

            {this.state.SalesOrder.status === 1 ?
              <div className="alert alert-warning" role="alert">
                <h4>Sales Order in progress</h4>
                <p>This order is in progress.</p>
                <p>Please let the warehouse personnel know about any changes. They need to refresh/reload this sales order to apply the new updates.</p>
                <hr />
                <p>If you have any questions, please contact IT support.</p>
              </div>
              : null}

            {/* Start process with new SO o Existing SO */}
            {this.state.mode !== 'edit' ? (
              <div className='row d-flex justify-content-center pb-4'>
                <div className='col-md-10 InputText'>
                  <div className="card shadow">
                    <div className="card-body">
                      <div className="flex-nowrap d-flex" style={{ marginBottom: 0, justifyContent: 'space-around' }}>
                        {/* Validate is online */}
                        {isOnline ?
                            <button type="button" onClick={() => this.validationNewSalesOrder()} className="btn blueButton btn-lg shadow" style={{width: '45%'}}>
                              <FiCheckCircle /> New Order
                            </button>
                          :
                            <button type="button" onClick={() => this.offlineNewOrder()} className="btn orangeButtonv2 btn-lg shadow" style={{width: '45%'}}>
                              <FiCheckCircle /> New Order (Offline)
                            </button>
                        }

                        {/* Validate is online */}
                        {isOnline ?
                          <PreSalesOrderList disabled={false} headerName='' nombrePadre="SalesOrderListSO" Padre={this} width='45' />
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* SO general info */}
            <div className='row d-flex justify-content-center'>
              <div className='col-sm-12 col-md-10'>
                {this.state.SalesOrder && this.state.SalesOrder.NoOrder ?
                  <div className='row'>
                    <div className='col-sm-12 col-md-6'>
                      <div className='card' style={{ background: '#f1f1f1' }}>
                        <div className="card-body">
                          <div className='row'>
                            <div className='col-5 InputTextBolder text-end'><p>Order No: </p></div>
                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.NoOrder}</div>
                            <div className='col-5 InputTextBolder text-end'><p>Person No: </p></div>
                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.SalespersonNo}</div>
                            <div className='col-5 InputTextBolder text-end'><p>Price Level: </p></div>
                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.PriceLevel}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='card' style={{ background: '#f1f1f1' }}>
                        <div className="card-body">
                          <div className='col-sm-12 mb-3 d-flex justify-content-center'>
                            <div className="form-check d-flex align-items-center justify-content-center" style={{ border: '1px solid #ccc', borderRadius: 5, padding: '0px 8px 5px 8px' }}>
                              <input disabled={this.state.enableEdit} className="form-check-input textRadioButtonSize" value={'S'} onChange={this.valueRadioButton} id="SalesOrderStand" checked={this.state.SalesOrder.Type === 'S'} type="radio" name="typeSalesOrder" style={{ marginLeft: 0 }} />
                              <label className="form-check-label textRadioButtonSize InputTextBolderSimple ms-2 pt-2" htmlFor="SalesOrderStand" style={{ fontSize: '18px' }}>
                                Standard
                              </label>
                            </div>
                          </div>

                          <hr />

                          {getValueCookie('CompanyId') === '6' ? 
                            <div className='col-sm-12'>
                              <div className='row' >
                                <div className='col-12 InputTextBolder text-start'><p>Type of Packaging: </p></div>
                                <div className='col-12 pb-3'>
                                  {this.state.selectedPacking}
                                </div>
                              </div>
                            </div>
                          : 
                            <div className='col-sm-12'>
                              <div className='row' >
                                <div className='col-12 InputTextBolder text-start'><p>Type of Packaging: </p></div>
                                <div className='col-12 pb-3'>
                                  <Select value={this.state.selectOptions1[(getIndexElement(this.state.selectOptions1, 'value', this.state.selectedPacking))]} isDisabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} className='fs-5 text-start' options={this.state.selectOptions1} onChange={(e) => this.onChangeSelects(e, "Packing")} placeholder="Select Type of Packaging" />
                                </div>
                              </div>
                            </div>
                          }

                          <hr />
                          
                          {getValueCookie('CompanyId') === '6' ? 
                            <div className='col-sm-12'>
                              <div className='row' >
                                <div className='col-12 InputTextBolder text-start'><p>Need to be Weighed? </p></div>
                                <div className='col-12 pb-3'>
                                  {this.state.selectedWeight}
                                </div>
                              </div>
                            </div>
                          : 
                            <div className='col-sm-12' hidden={getValueCookie('CompanyId') === '6'}>
                              <div className='row' >
                                <div className='col-12 InputTextBolder text-start'><p>Need to be Weighed?</p></div>
                                <div className='col-12 pb-3'>
                                  <Select value={this.state.selectOptions3[(getIndexElement(this.state.selectOptions3, 'value', this.state.selectedWeight))]} isDisabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} className='fs-5 text-start' menuPortalTarget={document.body} menuPosition='fixed' styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={this.state.selectOptions3} onChange={(e) => this.onChangeSelects(e, "Weight")} placeholder="Select Type of Packaging" />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
              </div>
            </div>
            {/* control sale order final*/}

            {/* Customer details */}
            <div className='row pt-1 pb-2' style={{ display: this.state.SalesOrder && this.state.SalesOrder.NoOrder ? 'block' : 'none' }}>
              {this.state.mode !== 'edit' ?
                <div className='row d-flex justify-content-center pb-4'>
                  <div className='col-md-10 InputText'>
                    <div className="card shadow">
                      <div className="card-body d-flex justify-content-center">
                        <CustomerListV2 disabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} headerName='Customer' nombrePadre="SalesOrder" Padre={this} isOnline={isOnline} />
                      </div>
                    </div>
                  </div>
                </div>
              : null}

              <div className='row d-flex justify-content-center'>
                <div className='col-sm-12 col-md-10'>
                  <div className='card' style={{ background: '#f1f1f1' }}>
                    <div className="card-body">
                      <div className="row">
                        <div className='col-sm-6'>
                          <div className='row'>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Customer No: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerNo}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Name: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerName}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Address Line: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.AddressLine1}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>City: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.City}</div>
                              </div>
                            </div>
                            <div hidden={getValueCookie('CompanyId') !== '6'} className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Unique Tracking: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.uniqueTrack}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className='row'>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Zip Code: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.ZipCode}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>State: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.State}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Telphone No: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.TelephoneNo}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Email Address: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.EmailAddress}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* customer details final */}
            
            {/* Catalogue section */}
            <div className='row' style={{ display: this.state.SalesOrder && this.state.SalesOrder.NoOrder && this.state.SalesOrder.Customer && this.state.SalesOrder.Customer.CustomerNo ? 'block' : 'none' }}>
              <div className='d-flex justify-content-center'>
                <div className='col-sm-12 col-md-10'>

                  <div hidden={Number(getValueCookie('SubCompanyId')) !== 5}>
                    <div className="card shadow">
                      <div className="card-body">
                        <div className='col-sm-12 InputTextBolder'><p>Warehouse: </p></div>
                        <div className='col-sm-12 pb-3'>
                          <Select value={this.state.selectOptions2[(getIndexElement(this.state.selectOptions2, 'value', this.state.SalesOrder.Warehouse))]} isDisabled={false} className='fs-4 text-start' options={this.state.selectOptions2} onChange={(e) => this.onChangeSelects(e, "Warehouse")} placeholder="Select Warehouse" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card with buttons for catalogue and print */}
                  <div className='col-sm-12 pt-2'>
                    <div className="card shadow">
                      <div className="card-body">
                        <div className="input-group input-group-lg flex-nowrap justify-content-between mb-0">
                          {/* Add by item code */}
                          <SearchUPC ComponentName={'SalesOrder'} disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} Padre={this} priceLevel={this.state.SalesOrder.Customer.PriceLevel} width='50' />

                          <div className='w-50 d-flex justify-content-end align-items-center flex-row'>
                            {/* Catalogue */}
                            <div className='me-2'>
                              <PreCatalogue Customer={this.state.SalesOrder.Customer} hidden={false} id='PreCatalogue' PriceLevel={this.state.SalesOrder.Customer.PriceLevel} Array={'Products'} nombrePadre={"SalesOrder"} colorButton='blueButton' Padre={this} disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.SalesOrder.status === 2} titleButton='Open Catalogue' needPrice={getValueCookie('SalesPerson') === '0010' ? false : true} needCost={getValueCookie('SalesPerson') === '0010' ? true : false} productList={'ProductList'} isOnline={isOnline} />
                            </div>

                            {/* Print button */}
                            {
                              isOnline?
                                MobileDisp() ?
                                  <OrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                    companyLogo={getValueCookie('DocumentsLogo')}
                                    OrderTitle="Pre-Sales Order"
                                    contactInfo={this.state.companyPrintHeader}
                                    OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                      "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                      "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                      "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                      "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                      "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                      "State:", this.state.SalesOrder.Customer.State, "", ""
                                    ]}
                                    headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                    bodyTable={this.detailToPrint()}
                                    headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                    bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                    styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                    comment={""}
                                    breakpoint={52}
                                    keysDecimalFormat={["UnitPrice", "totalCost"]}
                                    disabled={this.state.SalesOrder.Customer.CustomerNo === ''}
                                  />
                                  :
                                  <DownloadOrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                    companyLogo={getValueCookie('DocumentsLogo')}
                                    OrderTitle="Sales Order"
                                    contactInfo={this.state.companyPrintHeader}
                                    OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                      "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                      "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                      "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                      "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                      "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                      "State:", this.state.SalesOrder.Customer.State, "", ""
                                    ]}
                                    docname={this.state.SalesOrder.NoOrder}
                                    headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                    bodyTable={this.detailToPrint()}
                                    headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                    bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                    styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                    comment={""}
                                    breakpoint={52}
                                    keysDecimalFormat={["UnitPrice", "totalCost"]}
                                    disabled={this.state.SalesOrder.Customer.CustomerNo === ''}
                                  />
                              :<></>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* List of selected products section */}
            {this.state.SalesOrder && this.state.SalesOrder.NoOrder && this.state.SalesOrder.Customer && this.state.SalesOrder.Customer.CustomerNo ? 
              <div className='row d-flex justify-content-center mt-4'>
                <div className='col-sm-12 col-md-10 tableFixHead'>
                  <table className='table table-striped align-middle table-hover'>
                    <thead>
                      <tr>
                        <th className='text-center'>Item  Code</th>
                        <th className='text-center'>Description</th>
                        <th className='text-center'>Quantity</th>
                        <th className='text-center'>Weight</th>
                        <th className='text-center'>Total Weight</th>
                        <th className='text-center'>Unit Price</th>
                        <th className='text-center'>Total</th>
                        <th className='text-center'></th>
                        <th className='text-center'></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.Products.map((item, i) => (
                        <tr key={i} hidden={item.Visible === 0} className={item.duplicate ? item.duplicate : (item.UnitPrice <= 0 ? 'bg-warning' : '')}>
                          <td className='text-center'>{item.itemCode}</td>
                          <td className='text-start'>{(item.completeDesc !== "null" && item.completeDesc) ? item.completeDesc : item.abbreviatedDesc}</td>
                          <td>
                            <div className="input-group  input-group-lg">
                              <input disabled={this.state.SalesOrder.status === 2} type="number" id={'quantityOrderedSalesOrder_' + i} min={0} defaultValue={item.quantityOrdered} onChange={(e) => this.onTarget(e, item)} className="form-control text-center inputResize" />
                            </div>
                          </td>
                          <td className='text-center textTableSize text-secondary' >{item.ShipWeight + ' lbs'}</td>
                          <td className='text-center textTableSize text-secondary'> {NumberFormat(pricesFormat(item.quantityOrdered * item.ShipWeight)) + ' lbs'}</td>
                          <td >
                            <div className="input-group input-group-lg flex-nowrap">
                              <span className="input-group-text">$</span>
                              <input disabled id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" />
                              {/* <input hidden={getValueCookie('userName') !== 'josue.contreras'} disabled={this.state.enableEdit || (getValueCookie('userName') !== 'josue.contreras' && getValueCookie('TypeUser') !== 1)} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} value={item.UnitPrice} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" /> */}
                              {/* <td hidden={getValueCookie('userName') === 'josue.contreras'} className='text-start'>{item.UnitPrice}</td> */}
                            </div>
                          </td>
                          <td className='text-end textTableSize text-success'> $ {NumberFormat(Number(item.totalCost).toFixed(2))}</td>
                          <td>
                            <div className="d-grid gap-1">
                              <button disabled={this.state.SalesOrder.status === 2} type="button" onClick={() => this.addComentary(item)} className="btn grayButton btn-lg text-wrap"> <AiOutlineComment /> </button>
                            </div>
                          </td>
                          <td>
                            <div className="d-grid gap-2">
                              <button disabled={this.state.SalesOrder.status === 2} type="button" onClick={() => this.removeProduct(item)} className="btn redButton btn-lg"><FiTrash /></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className='tfoot'>
                      <tr className='' style={{ background: '#79c7cc', color: 'white' }}>
                        <td></td>
                        <td className='text-center textTableSize'>Totals</td>
                        <td className='text-center textTableSize'>{NumberFormat(this.state.SalesOrder.TotalQuantityOrdered)}</td>
                        <td></td>
                        <td className='text-center textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalWeight) + ' lbs')} </td>
                        <td className='text-end textTableSize'>$</td>
                        <td className='text-end textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            : null }
            {/* products details final */}

            {/* Order save and clear section */}
            {this.state.SalesOrder && this.state.SalesOrder.NoOrder && this.state.SalesOrder.Customer && this.state.SalesOrder.Customer.CustomerNo ? 
              <div className='row pb-2 d-flex justify-content-center'>
                <div className='col-10'>
                  <div className="">
                    <div className="d-flex justify-content-center">
                      {isOnline && !wasOffline ?
                        <button disabled={this.state.Products.length === 0 || this.state.isInputFocused} type="button" onClick={() => this.createSalesOrder(1)} className="btn greenButton btn-lg"><FiSave /> Save and Print</button>
                        : null}
                      {/* Was offline at least 1 time */}
                      {isOnline && wasOffline ?
                        <button disabled={this.state.Products.length === 0 || this.state.isInputFocused || !this.state.isMayalandOrder || this.state.SalesOrder.status === 2} type="button" onClick={() => this.createSalesOrderSync(1)} className="btn greenButtonv2 btn-lg"><FiCheckSquare /> Save and Print</button>
                        : null}

                      <button type="button" onClick={() => this.clearSalesOrderCache()} className="btn purpleButtonv2 btn-lg ms-2"><FiRefreshCw /> Clear order</button>
                    </div>
                  </div>
                </div>
              </div>
            : 
              <div>
                {this.state.SalesOrder && this.state.SalesOrder.NoOrder ? 
                  <div className='row pb-2 d-flex justify-content-center'>
                    <div className='col-10'>
                      <div className="card shadow">
                        <div className="card-body d-flex justify-content-center">
                          <button type="button" onClick={() => this.clearSalesOrderCache()} className="btn purpleButtonv2 btn-lg"><FiRefreshCw /> Clear order</button>
                        </div>
                      </div>
                    </div>
                  </div>
                : null}
              </div>
            }
            {/* pdf order final */}

            {/* modal Balance inicio*/}
            <SmallModal centered={false} size={'xl'} title={'Balance: ' + this.state.SalesOrder.Customer.CustomerName} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
              <div className='row pt-2'>
                <div className='col-sm-12 pb-2'>
                  <h3>Terms Code: {this.state.Balance.TermsCode}</h3>
                </div>
                <div className='col-sm-12 tableFixHead'>
                  <table className='table table-hover text-center'>
                    <thead className='thead'>
                      <tr className='bg-dark'>
                        <th>Invoice No</th>
                        <th>Date</th>
                        <th>Due Date</th>
                        <th>Payment Delay Days</th>
                        <th>Customer Name</th>
                        <th>Sales Person</th>
                        <th></th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.Balance.HeaderBalance.map((element, e) => (
                          <tr className={element.InvoiceNo === this.state.Balance.SelectedInvoice ? 'bg-warning' : ''} onClick={() => this.getDetailBalance(element)} key={e}>
                            <td className='text-start'>{element.InvoiceNo}</td>
                            <td>{element.InvoiceDate}</td>
                            <td>{element.InvoiceDueDate}</td>
                            <td>{element.PaymentDelayDays}</td>
                            <td>{this.state.SalesOrder.Customer.CustomerName}</td>
                            <td>{element.SalespersonNo}</td>
                            <td>$</td>
                            <td className='text-end'>{NumberFormat(pricesFormat(element.Balance))}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                    <tfoot className='tfoot'>
                      <tr className='table-dark'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>TOTAL:</td>
                        <td>$</td>
                        <td className='text-end'>{NumberFormat(pricesFormat(this.state.Balance.TotalBalance))}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className='col-sm-12'>
                  <h3 className='text-start'>Detail: {this.state.Balance.SelectedInvoice}</h3>
                </div>
                <div className='col-sm-12 tableFixHead'>
                  <table className='table table-hover text-center'>
                    <thead className='thead'>
                      <tr>
                        <th>Invoice No</th>
                        <th>Invoice Type</th>
                        <th>Transaction Type</th>
                        <th>Transaction Date</th>
                        <th></th>
                        <th>Transaction Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.Balance.Detail.map((element, e) => (
                          <tr key={e}>
                            <td className='text-start'>{element.InvoiceNo}</td>
                            <td>{element.InvoiceType}</td>
                            <td>{element.TransactionType}</td>
                            <td>{DateFormatMAS90(element.TransactionDate)}</td>
                            <td className='text-end'>$</td>
                            <td className='text-end'>{NumberFormat(pricesFormat(element.TransactionAmt))}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                    <tfoot className='tfoot'>
                    </tfoot>
                  </table>
                </div>

                <div className='col-sm-6 pt-2'>
                  {
                    MobileDisp() ?
                      <OrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                        companyLogo={getValueCookie('DocumentsLogo')}
                        OrderTitle="Current Balance"
                        contactInfo={this.state.companyPrintHeader}
                        OrderInfo1={[
                          "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                          "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                          "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                          "Address:", this.state.SalesOrder.Customer.AddressLine1, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                          "City", this.state.SalesOrder.Customer.City, "", ""
                        ]}
                        headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "Customer\nName", "Sales\nPerson", "", "Balance"]}
                        bodyTable={this.state.Balance.HeaderBalance}
                        headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "CustomerName", "SalespersonNo", "dolar", "Balance"]}
                        bottomInfo={["", "", "", "", "", "TOTAL", "$", NumberFormat(pricesFormat(this.state.Balance.TotalBalance))]}
                        styleColumns={["ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaCantidades", "ColumnaTextoLargo2", "ColumnaCantidades", "Dolar", "ColumnaPrecios"]}
                        hidden={false}
                        comment={""}
                        keysDecimalFormat={["Balance"]}
                        breakpoint={28}
                        disabled={false}
                        titleButton='Print Balance'
                      />
                      :
                      <DownloadOrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                        companyLogo={getValueCookie('DocumentsLogo')}
                        docname={'Balance ' + this.state.SalesOrder.Customer.CustomerName}
                        OrderTitle="Current Balance"
                        contactInfo={this.state.companyPrintHeader}
                        OrderInfo1={[
                          "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                          "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                          "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                          "Address:", this.state.SalesOrder.Customer.AddressLine1, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                          "City", this.state.SalesOrder.Customer.City, "", ""
                        ]}
                        headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "Customer\nName", "Sales\nPerson", "", "Balance"]}
                        bodyTable={this.state.Balance.HeaderBalance}
                        headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "CustomerName", "SalespersonNo", "dolar", "Balance"]}
                        bottomInfo={["", "", "", "", "", "TOTAL", "$", NumberFormat(pricesFormat(this.state.Balance.TotalBalance))]}
                        styleColumns={["ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaCantidades", "ColumnaTextoLargo2", "ColumnaCantidades", "Dolar", "ColumnaPrecios"]}
                        hidden={false}
                        comment={""}
                        keysDecimalFormat={["Balance"]}
                        breakpoint={28}
                        disabled={false}
                        titleButton='Print Balance'
                      />
                  }
                </div>
                <div className='col-sm-6 pt-2'>
                  <div className="d-grid gap-2">
                    <button type="button" onClick={() => this.handleModalClose("showModal1")} className="btn redButton btn-lg">Close</button>
                  </div>
                </div>
              </div>
            </SmallModal>
            {/* modal Balance final*/}
          </div>
        </div>
      </div>
    )
  }
}
